// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MehFilledSvg from "@fishx/icons-svg/es/asn/MehFilled";
import FishxIcon from '../components/FishxIcon';

var MehFilled = function MehFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MehFilledSvg
  }));
};

MehFilled.displayName = 'MehFilled';
export default React.forwardRef(MehFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MehFilled.js
// module id = 3105
// module chunks = 0